import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

type BuildPhase = {
  // Предмет в этой фазе, если сильные покупают его раньше этой секунды матча.
  untilS: number;
  label: MessageDescriptor;
};

// Фазы матча для закупа раскрытой сборки: линия до 10:00, середина до 25:00 (до этой минуты
// разбор и каталог определяют тип сборки), дальше — поздняя игра.
export const BUILD_PHASES: readonly BuildPhase[] = [
  { untilS: 10 * 60, label: msg({ id: "builds.phase.lane", message: "Laning · before 10:00" }) },
  {
    untilS: 25 * 60,
    label: msg({ id: "builds.phase.mid", message: "Mid game · 10–25 minutes" }),
  },
  {
    untilS: Number.POSITIVE_INFINITY,
    label: msg({ id: "builds.phase.late", message: "Late game · after 25:00" }),
  },
];
